module.exports = __webpack_public_path__ + "static/media/partitionBottomImg3.2c88c59f.png";